"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackgroundColor = void 0;
const constants_1 = require("./constants");
const getBackgroundColor = (view) => {
    return view ? constants_1.pageLayoutBackgroundColorMapper[view] : 'transparent';
};
exports.getBackgroundColor = getBackgroundColor;
//# sourceMappingURL=getBackgroundColor.js.map